import React from "react"

import SimpleSlider from "./Sliders/SimpleSlider"

function Testimonials() {
  return (
    <SimpleSlider>
      {testimonials.map(function (testimonial, idx) {
        return (
          <Testimonial
            key={idx}
            name={testimonial.name}
            description={testimonial.description}
            img_name={testimonial.img_name}
            quote={testimonial.quote()}
          />
        )
      })}
    </SimpleSlider>
  )
}

function Testimonial(props) {
  return (
    <div key={props.key} className="item text-center">
      <i className="tf-ion-chatbubbles"></i>
      <div className="client-details">{props.quote}</div>
      <div className="client-thumb">
        <img
          src={`/images/client-logo/${props.img_name}.jpg`}
          className="img-responsive"
          alt={props.description}
        />
      </div>
      <div className="client-meta">
        <h3>{props.name}</h3>
        <span>{props.description}</span>
      </div>
    </div>
  )
}

const testimonials = [
  {
    name: "Alvin Vuong",
    description: "CEO, Escality, LLC",
    img_name: "clients-1",
    quote: () => (
      <>
        <p>
          "We had an amazing time working with CYC at UCLA! From their highly
          polished presentations to their well-thought out insights and
          suggestions, we are extremely grateful for their help in planning out
          our product roadmap for the upcoming months. Their advice has prepared
          us for the upcoming release of our next title and allowed us to begin
          the work needed to prepare for marketing at scale."
        </p>
      </>
    ),
  },
  {
    name: "Kristin Wuhrman",
    description: "VP of Business Development, Basepaws",
    img_name: "clients-2",
    quote: () => (
      <>
        <p>
          "As a start-up in the animal health space, I can\'t say enough
          positive things about our opportunity to partner with Consult Your
          Community at UCLA. Such a dedicated, talented and driven group of
          individuals. The collaborative engagement we partnered on not only
          fined-tuned the vision of a new product, but provided us with valuable
          strategic direction in taking it market. Huge success!"
        </p>
      </>
    ),
  },
  {
    name: "Francesco Da Vinco",
    description: "CEO, Francesco Productions",
    img_name: "clients-3",
    quote: () => (
      <>
        <br />
        <p>
          "If I was running for office, this is the kind of team I would want
          around me! The team members have not only proven themselves to be
          dedicated to excellence, but they\'ve been personable and a pleasure
          to work with!"
        </p>
        <br />
      </>
    ),
  },
]

export default Testimonials
